import ProductoCrud from './ProductoCrud'
export {ProductoCrud}
export default ProductoCrud
